<template>
    <div>
        <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
        <el-dialog :visible="dialogVisible" title="新建项目" width="50%" @close="closeDialog">
            <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
                <el-form-item label="描述：" prop="description">
                    <el-input v-model="detail.description"/>
                </el-form-item>
                <el-form-item label="类别">
                    <el-select v-model="detail.taskType">
                        <el-option v-for="item in dropType" :label="item.desc" :key="item.code" :value="item.code"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否发送短信">
                    <el-switch v-model="detail.sendMsg" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapActions,
        mapState
    } from 'vuex';

    export default {
        name: 'airdropCreate',
        data() {
            return {
                dialogVisible: false,
                detail: {sendMsg: true, taskType: 0, description: ""},
                rules: {
                    description: {required: true, message: '请填写描述'},
                    taskType: {required: true, message: '请选择类型'}
                },
                dropType: [{code: 0, desc: '投入空投'}]
            };
        },

        methods: {
            ...mapActions('incubatorAirDrop', ['create']),
            closeDialog() {
                this.dialogVisible = false;
                this.detail = {sendMsg: true, taskType: 0, description: ""};
                this.$refs['form'].resetFields();
            },
            handleSave() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.create(this.detail).then(() => {
                            this.$message({message: '添加成功！', type: 'success'});
                            this.dialogVisible = false;
                            this.$emit('refresh', {page: 1});
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="less">
    .editor {
        height: 500px;
    }
</style>
